<template>
  <button :class="classes" @click="onClick">
    <div class="trbo-a-question-next-button__wrapper">
      <icon name="skip" class="trbo-a-question-next-button__icon" />
      <div class="trbo-a-question-next-button__title">
        {{ $t('wizard.skip') }}
      </div>
    </div>
  </button>
</template>

<script>
// @flow

import Icon from '../../Icon/Icon.vue'

export default {
  components: {
    Icon
  },
  computed: {
    classes () {
      return {
        'trbo-a-question-next-button': true,
        'trbo-a-question-next-button--is-skip': true
      }
    }
  },
  methods: {
    onClick () {
      this.$emit('click', 'next')
    }
  }
}
</script>

<style scoped src="../NextButton/next-button.scss" />
